
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Menu, X } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

// Import the new components
import Logo from "./navbar/Logo";
import NavItems from "./navbar/NavItems";
import ContactInfo from "./navbar/ContactInfo";
import ConsultationButton from "./navbar/ConsultationButton";
import MobileMenu from "./navbar/MobileMenu";
import { getNavLinks } from "./navbar/navConfig";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isMobile = useIsMobile();
  const navLinks = getNavLinks();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
        isScrolled
          ? "bg-background/95 backdrop-blur-md py-3 shadow-md border-b border-accent/15 text-foreground"
          : "bg-primary/90 backdrop-blur-sm py-4 border-b border-accent/15 text-primary-foreground"
      )}
    >
      <div className="page-container">
        <div className="flex items-center justify-between">
          <Logo isScrolled={isScrolled} />

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center">
            <NavItems navLinks={navLinks} isScrolled={isScrolled} />
          </div>

          <div className="hidden md:flex items-center">
            <ContactInfo className="mr-6" isScrolled={isScrolled} />
            <ConsultationButton className="py-6 px-5" />
          </div>

          <button
            className="md:hidden p-2 rounded-md z-10"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <MobileMenu isOpen={mobileMenuOpen} navLinks={navLinks} />
    </header>
  );
};

export default Navbar;
